<template>
  <div class="bordered-group vs-card vs-con-block mt-5">
    <div class="vs-card-content">
      <div class="vx-row ">
        <div class="vx-col w-full">
          <vs-table max-items="10" :data="expenseDetails">
            <template slot="header">
              <div class="vx-row  w-full mb-1 mr-0 ml-0 p-0">
                <div class="vx-col w-1/3">
                  <h6>ข้อมูลค่าใช้จ่าย</h6>
                </div>
                <div class="vx-col w-2/3 flex justify-end m-0 p-0">
                  <vs-button color="success" type="filled" icon-pack="feather" icon="icon-plus"  @click="onPressedActiveAddExpenseDetail()">เพิ่มข้อมูล</vs-button>
                </div>
              </div>
            </template>

            <template slot="thead">
              <vs-th >#</vs-th>
              <vs-th >วันที่</vs-th>
              <vs-th >ประเภท</vs-th>
              <vs-th >จำนวน</vs-th>
              <vs-th class="col-createdBy">ผู้บันทึก</vs-th>
              <vs-th class="col-approved">สถานะ</vs-th>
              <vs-th class="col-actions"></vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="row" :key="index" v-for="(row, index) in data">
                <vs-td>{{ data.length - index }}</vs-td>
                <vs-td>{{ row.expenseDateLocalTh }}</vs-td>
                <vs-td>{{ row.expenseTypeName }}</vs-td>
                <vs-td class="text-right">{{ row.amount | numberFormat }}</vs-td>
                <vs-td>{{ row.createByFullName }}<br>{{ row.createdAtLocalTh }}</vs-td>
                <vs-td>
                  <vs-chip  v-if="row.approvedStatus === IApprovedStatus.draft" color="warning">รอยืนยัน</vs-chip>
                  <vs-chip  v-if="row.approvedStatus === IApprovedStatus.approved" color="success">ยืนยันแล้ว</vs-chip>
                  <vs-chip  v-if="row.approvedStatus === IApprovedStatus.cancel" color="danger">ยกเลิก</vs-chip>
                </vs-td>
                <vs-td>
                  <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
                    <vx-tooltip text="ยืนยันข้อมูลค่าใช้จ่าย">
                      <vs-button  class="mr-1" color="success" type="filled" icon-pack="feather" icon="icon-check" @click="onPressedApprovedExpenseDetail(row.id)" v-if="row.approvedStatus === IApprovedStatus.draft"></vs-button>
                    </vx-tooltip>
                    <vx-tooltip text="แก้ไขข้อมูลค่าใช้จ่าย">
                      <vs-button  class="mr-1" color="warning" type="filled" icon-pack="feather" icon="icon-edit" @click="onPressedActiveUpdateExpenseDetail(row)" v-if="row.approvedStatus === IApprovedStatus.draft"></vs-button>
                    </vx-tooltip>
                    <vx-tooltip text="ยกเลิกข้อมูลค่าใช้จ่าย">
                      <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-x-circle" @click="onPressedCanceledExpenseDetail(row.id)" v-if="row.approvedStatus === IApprovedStatus.approved && isRoot"></vs-button>
                    </vx-tooltip>
                    <vx-tooltip text="ลบข้อมูลค่าใช้จ่าย">
                      <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-trash" @click="onPressedDelExpenseDetail(row.id)" v-if="row.approvedStatus === IApprovedStatus.draft"></vs-button>
                    </vx-tooltip>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>

    <vs-popup
      :active.sync="expenseDetailModal.active"
      :title="expenseDetailModal.title"
      class="custom-popup"
    >
      <div class="popup-content">
        <ValidationObserver v-slot="{ handleSubmit }" ref="form">
          <form @submit.prevent="handleSubmit">
          <div class="vx-row">
            <div class="vx-col w-1/2">
              <ValidationProvider name="วันที่" rules="required" v-slot="{ errors }" >
                <label class="text-sm">วันที่*</label>
                <flat-pickr :config="configDateExpenseDetail" class="w-full" v-model="expenseDetailModal.expenseDate"/>
                <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-1/2">
              <ValidationProvider name="จำนวน" :rules="{ required: true, min_value: 0.01 }"  v-slot="{ errors }" >
                <label class="text-sm">จำนวน*</label>
                <vs-input type="number" class="w-full" v-model="expenseDetailModal.amount"/>
                <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <validation-provider name="ประเภท" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">ประเภท*</label>
                <v-select v-model="expenseDetailModal.expenseType" :clearable="false" :options="expenseTypesOptions" :reduce="res => res.value" name="expenseType" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <validation-provider name="หมายเหตุ" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">หมายเหตุ*</label>
                <vs-textarea  v-model="expenseDetailModal.remark" rows="5"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          </form>
        </ValidationObserver>
      </div>
      <div class="popup-footer">
        <vs-button color="success" @click="onPressedAcceptExpenseDetailModel">บันทึก</vs-button>
        <vs-button color="danger" @click="expenseDetailModal.active = false">ยกเลิก</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import Divider from "@/views/components/vuesax/divider/Divider.vue";
import {createNamespacedHelpers, mapGetters} from "vuex";
import vSelect from "vue-select";
import moment from "moment";
import { Thai } from 'flatpickr/dist/l10n/th'
import 'flatpickr/dist/themes/dark.css';
import flatPickr from "vue-flatpickr-component";
import {IApprovedStatus, IExpenseType} from "@/constants/interface";
const {mapActions: mapAccountingActions, mapState: mapAccountingFields} = createNamespacedHelpers('Accounting');

export default {
  name: 'ExpenseInfoTab',
  components: {
    vSelect,
    Divider,
    flatPickr
  },
  data() {
    return {
      clearTransactionsPopup: {
        active: false,
        date: moment().format('DD-MM-YYYY'),
      },
      expenseDetailModal: {
        active: false,
        type: 'add',
        title: 'เพิ่มข้อมูลค่าใช้จ่าย',
        id: null,
        expenseDate: moment().format('DD-MM-YYYY'),
        expenseType: IExpenseType.processingFee,
        amount: 0,
        remark: "",
      },
    };
  },
  computed: {
    IApprovedStatus() {
      return IApprovedStatus
    },
    ...mapGetters({
      expenseTypesOptions :'Master/expenseTypesOptions',
    }),
    ...mapAccountingFields(['contractDetail','contractDetailExpenseDetails']),
    configDateExpenseDetail(){
      let minDate = null
      let maxDate = null

      return {
        monthSelectorType: "static",
        allowInput: true,
        locale: Thai,
        dateFormat: "d-m-Y",
        minDate,
        maxDate
      }
    },
    expenseDetails() {
      if (!this.contractDetailExpenseDetails) return null;
      return [...this.contractDetailExpenseDetails]
        .sort(({ expenseDate: aExpenseDate, createdAt: aCreatedAt }, { expenseDate: bExpenseDate, createdAt: bCreatedAt }) => {
          const expenseDateDiff = new Date(bExpenseDate) - new Date(aExpenseDate);
          if (expenseDateDiff !== 0) {
            return expenseDateDiff;
          }
          return new Date(bCreatedAt) - new Date(aCreatedAt);
        })
        .map((expenseDetail) => {
          const {
              id,
              expenseDate,
              expenseType,
              amount,
              expenseTypeName,
              createdAtLocalTh,
              createByFullName,
              expenseDateLocalTh,
              remark,
              approvedStatus,
          } = expenseDetail;

          return {
            id,
            expenseDate,
            expenseType,
            amount,
            expenseTypeName,
            createdAtLocalTh,
            createByFullName,
            expenseDateLocalTh,
            remark,
            approvedStatus,
          }
        })
    },
  },
  methods: {
    ...mapAccountingActions(['getContractDetail', 'approvedContractDetailExpenseDetail', 'createContractDetailExpenseDetail', 'approvedContractDetailExpenseDetail', 'canceledContractDetailExpenseDetail', 'updateContractDetailExpenseDetail', 'deleteContractDetailExpenseDetail']),
    async onPressedActiveAddExpenseDetail() {
      const vm = this
      vm.expenseDetailModal.active = true
      vm.expenseDetailModal.type = 'add'
      vm.expenseDetailModal.id = null
      vm.expenseDetailModal.title = 'เพิ่มข้อมูลค่าใช้จ่าย';
      vm.expenseDetailModal.expenseDate = moment().format('DD-MM-YYYY');
      vm.expenseDetailModal.expenseType = IExpenseType.processingFee;
      vm.expenseDetailModal.amount = 0;
      vm.expenseDetailModal.remark = "";
    },
    async onPressedApprovedExpenseDetail(id) {
      const vm = this
      const contractId  = vm.$route.params.id;
      const { approvedContractDetailExpenseDetail, getContractDetail } = vm;
      vm.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'ยืนยันข้อมูล',
        text: 'คุณต้องการยืนยันข้อมูลใช่หรือไม่?',
        acceptText: 'ใช่',
        accept: async () => {
          await approvedContractDetailExpenseDetail({
            id,
            vm
          });
          await getContractDetail({
            id: contractId
          })
        }
      })
    },
    async onPressedCanceledExpenseDetail(id) {
      const vm = this
      const contractId  = vm.$route.params.id;
      const { canceledContractDetailExpenseDetail, getContractDetail } = vm;
      vm.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'ยืนยันการยกเลิกข้อมูล',
        text: 'คุณต้องการยกเลิกข้อมูลใช่หรือไม่?',
        acceptText: 'ใช่',
        accept: async () => {
          await canceledContractDetailExpenseDetail({
            id,
            vm
          });
          await getContractDetail({
            id: contractId
          })
        }
      })
    },
    async onPressedActiveUpdateExpenseDetail(row) {
      const vm = this;
      vm.expenseDetailModal.active = true;
      vm.expenseDetailModal.id = row.id;
      vm.expenseDetailModal.type = 'update';
      vm.expenseDetailModal.title = 'แก้ไขข้อมูลค่าใช้จ่าย';
      vm.expenseDetailModal.expenseDate = moment(row.expenseDate).format('DD-MM-YYYY');
      vm.expenseDetailModal.expenseType = row.expenseType;
      vm.expenseDetailModal.amount = row.amount;
      vm.expenseDetailModal.remark = row.remark;
    },
    async onPressedAcceptExpenseDetailModel() {
      const vm = this
      const contractId  = vm.$route.params.id;
      const {createContractDetailExpenseDetail, updateContractDetailExpenseDetail, getContractDetail } = vm;
      vm.$refs['form'].validate().then(async success => {
        if (!success) {
          return
        }
        const expenseDate = vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.expenseDetailModal.expenseDate.trim())
        if(vm.expenseDetailModal.type === 'add') {
          await createContractDetailExpenseDetail({
            contractId,
            form: {
              expenseDate,
              expenseType: vm.expenseDetailModal.expenseType,
              amount: parseFloat(vm.expenseDetailModal.amount),
              remark: vm.expenseDetailModal.remark,
            }
          })
        }else if(vm.expenseDetailModal.type === 'update') {
          await updateContractDetailExpenseDetail({
            id: vm.expenseDetailModal.id,
            form: {
              expenseDate,
              expenseType: vm.expenseDetailModal.expenseType,
              amount: parseFloat(vm.expenseDetailModal.amount),
              remark: vm.expenseDetailModal.remark,
            }
          })
        }
        await getContractDetail({
          id: contractId
        })
        vm.expenseDetailModal.active = false;
      })
    },
    async onPressedDelExpenseDetail(id) {
      const vm = this
      const { deleteContractDetailExpenseDetail } = vm;
      vm.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'ยืนยันการลบข้อมูล',
        text: 'คุณต้องการลบข้อมูลใช่หรือไม่?',
        acceptText: 'ใช่',
        accept: async () => {
          await deleteContractDetailExpenseDetail({
            id,
            vm
          })
        }
      })
    },
  }
}
</script>

<style scoped>
.vx-row {
  margin-bottom: 15px;
}

.col-createdBy {
  width: 200px;
}

.col-approved {
  width: 130px;
}

.col-actions {
  width: 100px;
}

.custom-popup .vs-popup {
  width: 600px;
}
.popup-content {
  padding: 10px;
}
.popup-footer {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  border-top: 1px solid #e0e0e0;
}
.popup-footer .vs-button + .vs-button {
  margin-left: 10px;
}
</style>
